import { Close as ResetIcon } from "@mui/icons-material";
import { IconButton, Stack } from "@mui/material";
import type { FC } from "react";
import DatePickerV2 from "../../components/datePicker/DatePickerV2";
import { Select } from "../../components/select/Select";
import dayjs, { ISO_DATE_FORMAT } from "../../dayjs";
import AgentSelect from "../../sharedComponents/agentSelect/AgentSelect";
import { useCustomerNoteTypes } from "../dictionaries/useCustomerNoteTypes";
import type { CustomerNotesFilters } from "../useAdminFilters";

interface Props {
  readonly filters: CustomerNotesFilters;
  readonly onChange: (filters: CustomerNotesFilters) => void;
}

const defaultFilters = (): CustomerNotesFilters => ({
  dateFrom: dayjs().subtract(7, "day").format(ISO_DATE_FORMAT),
  dateTo: dayjs().format(ISO_DATE_FORMAT),
  accountManagerId: null,
  authorId: null,
  type: null,
});

const CustomerNotesSearch: FC<Props> = ({ filters, onChange }) => {
  const { noteTypes } = useCustomerNoteTypes();

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: "center",
      }}
    >
      <AgentSelect
        agentId={filters.accountManagerId}
        onChange={(id) => onChange({ ...filters, accountManagerId: id })}
      />
      <AgentSelect label="Autor" agentId={filters.authorId} onChange={(id) => onChange({ ...filters, authorId: id })} />
      <Select
        label="Typ notatki"
        fullWidth
        value={filters.type ?? ""}
        values={[{ value: "", label: "Wszystkie" }, ...noteTypes.map((t) => ({ value: t.name, label: t.name }))]}
        onSelect={(v) => onChange({ ...filters, type: v || null })}
      />
      <DatePickerV2
        label="Od"
        fullWidth
        value={filters.dateFrom ? dayjs(filters.dateFrom, ISO_DATE_FORMAT) : null}
        onChange={(d) => onChange({ ...filters, dateFrom: d?.format(ISO_DATE_FORMAT) ?? "" })}
      />
      <DatePickerV2
        label="Do"
        fullWidth
        value={filters.dateTo ? dayjs(filters.dateTo, ISO_DATE_FORMAT) : null}
        onChange={(d) => onChange({ ...filters, dateTo: d?.format(ISO_DATE_FORMAT) ?? "" })}
      />
      <IconButton color="inherit" onClick={() => onChange(defaultFilters())}>
        <ResetIcon />
      </IconButton>
    </Stack>
  );
};

export default CustomerNotesSearch;
